import PermissionTemplatesView from "./PermissionsTemplateView";

export default class CreatePermissionsTemplateView extends PermissionTemplatesView {
    constructor($containerEl, params) {
        super($containerEl, params);
        this.state.id = null;
    }

    afterRender() {
        super.afterRender();
        this.$el.addClass("createTemplateView");
        this.$resetButton.hide();
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/permissionsTemplates/CreatePermissionsTemplateView.js